export enum TipoQuestionario {
  Suitability = 'Suitability',
}
